export const assemblyKeys = {
  all: ['assemblies'] as const,
  many: (queryProps?: Record<string, unknown>) => [...assemblyKeys.all, 'list', ...[queryProps]].filter(Boolean),
  one: (id: number) => [...assemblyKeys.all, 'detail', id] as const,
};
